<template>
  <canvas ref="canvas" v-bind="$attrs" />
</template>

<script>
  import {onBeforeUnmount, onMounted, ref} from '@vue/composition-api'

  import drawSkin3D from './namemc-skins'

  export default {
    name: 'SkinModel',

    props: {
      src: {
        type: String,
        required: true,
      },

      slim: {
        type: Boolean,
        required: false,
      },
    },

    setup (props) {
      const canvas = ref(null)
      const destroy = ref(null)

      onMounted(() => {
        destroy.value = drawSkin3D(canvas.value, props.src, props.slim)
      })

      onBeforeUnmount(() => {
        if (typeof destroy.value === 'function') {
          destroy.value()
        }
      })

      return {
        canvas,
        destroy,
      }
    },
  }
</script>
